import api from "api";
import { useMutation } from "react-query";

export type Movement =
  | "none"
  | "flexion"
  | "extension"
  | "abduction"
  | "adduction"
  | "internal_rotation"
  | "external_rotation"
  | "lateral_flexion";

export interface Vars {
  exerciseId: number;
  level: any;
  movement: Movement | null | undefined;
}

export const usePutLevelMovement = () =>
  useMutation((data: Vars) => {
    const movement = data.movement === "none" ? undefined : data.movement;
    const { translations, image_url, video, ...levelData } = data.level;

    // @ts-ignore
    return api(`PUT /exercises/${data.exerciseId}/levels/${data.level.id}`, {
      root: process.env.REACT_APP_API_URL_V2 + "/v2/support",
      data: {
        ...levelData,
        movement,
      },
    });
  });
